import * as actions from "./actions";

export default function customQuotePdfReducer(state = {}, action) {
    switch (action.type) {

    case actions.GET_CUSTOM_QUOTE_PDF_SUCCESS:
    case actions.GET_CUSTOM_QUOTE_PDF_FAIL:        
    {
        return action.payload;
    }
    case actions.GET_CUSTOM_QUOTE_PDF_TIMEOUT:
    {
        return {
            timedOut: true
        };
    }
    case actions.GET_CUSTOM_QUOTE_PDF_RESET:
    {
        return {};
    }
    default:
        return state;

    }
}
